import { get } from './apiServices'
import { token } from './authServices'

export const ROLE_PARENT = 'parent'
export const ROLE_CHILD = 'child'
export const ROLE_TEACHER = 'teacher'
export const ROLE_SUPERADMIN = 'super_admin'

export function is(account, roleNames){
	let condition = false

	if (!account || !account.roles)
		return condition

	roleNames.forEach(role => {
		condition = condition ?
			condition : account.user.type == account.roles[role]
	})

	return condition
}

export function check(){
    return get('/auth/check', token).then(res =>{
        return res.data;
    })
}

export function stages(page=1, all=false, levels=false){
    return get('/admin/stages?page=' + page + '&all=' + all + '&levels=' + levels, token).then(res =>{
        return res.data;
    })
}

export function levels(id){
    return get(`/admin/stages/${id}/levels`, token).then(res =>{
        return res.data;
    })
}

export function singleLevel(id){
    return get(`/admin/levels/${id}`, token).then(res =>{
        return res.data;
    })
}

export function accounts(page=1){
    return get('/admin/accounts?page=' + page, token).then(res =>{
        return res.data;
    })
}

export function users(id, page=1){
    return get(`/admin/accounts/${id}/users?page=${page}`, token).then(res =>{
        return res.data;
    })
}

export function currencies(page=1){
    return get(`/admin/settings/currency?page=${page}`, token).then(res =>{
        return res.data;
    })
}

export function countries(){
    return get('/admin/settings/countries', token).then(res =>{
        return res.data;
    })
}

export function schoolTypes(){
    return get('/admin/settings/school-types', token).then(res =>{
        return res.data;
    })
}

export function classRooms(accountId, page=1){
    return get(`/admin/accounts/${accountId}/classes?page=${page}`, token).then(res =>{
        return res.data;
    })
}

export function players(accountId, id){
    return get(`/admin/accounts/${accountId}/classes/${id}/players`, token).then(res =>{
        return res.data;
    })
}

export function teachers(accountId, page=1){
    return get(`/admin/accounts/${accountId}/teachers?page=${page}`, token).then(res =>{
        return res.data;
    })
}

export function settings(){
    return get(`/admin/settings`, token).then(res =>{
        return res.data;
    })
}

export function badges() {
    const config = `{
        items: achievements{
            id,
            type,
            icon, 
            condition,
            order,
            settings,
            title,
            title_colour,
            description,
            group{id}, 
            category{id}
        },
        categories: achievementCategories{
            id,
            icon,
            name
        },
        groups: achievementGroups{
            id,
            icon,
            icon_active,
            category{id}
        }
    }`

    return get('/graphql?query='+config, token).then(res =>{
        return res.data.data;
    })
}

export function parts() {
    const config = `{
        items: botParts{
            id,
            name,
            image_name, 
            price,
            status,
            category{id, name},
            groups{id, name},
        },
        categories: botPartCategories{
            id,
            name
        },
        groups: botPartGroups{
            id,
            name
        },
    }`

    return get('/graphql?query='+config, token).then(res =>{
        return res.data.data;
    })
}



// WEBPACK FOOTER //
// ./src/services/contentServices.js